module.exports = __webpack_public_path__ + "static/media/website.0a8dfefa.svg";